import { render, staticRenderFns } from "./BeuticianDataSheetsForm.vue?vue&type=template&id=1cc7abf6&scoped=true"
import script from "./BeuticianDataSheetsForm.vue?vue&type=script&lang=js"
export * from "./BeuticianDataSheetsForm.vue?vue&type=script&lang=js"
import style0 from "./BeuticianDataSheetsForm.vue?vue&type=style&index=0&id=1cc7abf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7abf6",
  null
  
)

export default component.exports